/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Check: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <g opacity='0.2'>
      <path
        d='M13.6728 3.34173C14.0058 3.04899 14.5137 3.05015 14.8456 3.35833C15.1775 3.66647 15.2161 4.1725 14.9491 4.5263L14.8915 4.59563L6.76651 13.3456C6.58772 13.5382 6.33145 13.6397 6.06925 13.623C5.80701 13.6061 5.56578 13.4725 5.413 13.2587L2.288 8.88372L2.23917 8.80853C2.01913 8.4235 2.12261 7.92641 2.49112 7.66302C2.85968 7.39976 3.36321 7.46308 3.65616 7.79583L3.71183 7.86614L6.2128 11.3681L13.6083 3.40423L13.6728 3.34173Z'
        fill='currentColor'
      />
    </g>
  </React.Fragment>
)
